import React from "react"
import './Button.scss'
import Icons from './Icons'


/**
 * added spread props
 * @param {*} props 
 * @returns 
 */
const BackButton = props =>{

    const { disabled=false } = props;

    return(
        <button className={`nova-back-btn`} onClick={props.onClick} disabled={disabled}>
            {  Icons.back } {props.text}
        </button>
    )
}
export default BackButton;